import React from "react";
import { useTranslation } from "react-i18next";
import { Cpu, Video, Flame, Shield, Radio, Droplet, Zap } from "lucide-react";
import SectionHeader from "../components/SectionHeader";

const TECHS = [
  { icon: Cpu, title: "IoT Solutions", desc: "Edge sensors, LoRa/NB-IoT gateways and a cloud twin that surfaces anomalies in real time. We instrument panels, pipes, pumps and people.", testid: "tech-iot" },
  { icon: Video, title: "AI Training Videos", desc: "Script-to-render pipeline for safety, SOP and onboarding videos — generative voiceover, animation and multi-language localisation.", testid: "tech-ai-video" },
  { icon: Zap, title: "Fire Prevention for Electrical", desc: "Arc-signature monitoring paired with live-load cleaning and non-flammable chemistry — preventing the failure chain end to end.", testid: "tech-electrical-fire" },
  { icon: Shield, title: "Hot-Pipe Insulation Cleaning", desc: "Dry-ice and low-pressure aqueous systems that clean hot, insulated piping without shutdown, wet-work or scaffolding.", testid: "tech-hot-pipe" },
  { icon: Flame, title: "Fire-Protection Paints", desc: "Intumescent coatings, ceramic matrix paints and cable-tray barriers engineered for structural-steel fire-rating compliance.", testid: "tech-paints" },
  { icon: Radio, title: "RF-Based Solutions", desc: "Sub-GHz asset trackers, industrial remote-actuation, hazardous-zone telemetry — Olivine-designed, hardened for heavy industry.", testid: "tech-rf" },
  { icon: Droplet, title: "EO-Based Solutions", desc: "Electro-optical thermal imagers, spark-detection cameras and hyperspectral sensors for condition inference and pre-ignition alerts.", testid: "tech-eo" },
];

export default function TechnologiesPage() {
  const { t } = useTranslation();
  return (
    <div data-testid="technologies-page" className="pb-24">
      <section className="border-b border-slate-800 py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <SectionHeader kicker="CAPABILITY PILLARS" title={t("technologies.title")} description={t("technologies.subtitle")} testIdPrefix="tech" />
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 border border-slate-800 grid-border">
            {TECHS.map((tc) => (
              <div key={tc.title} data-testid={tc.testid} className="p-8 bg-slate-950 hover:bg-slate-900 transition-colors group">
                <div className="w-11 h-11 flex items-center justify-center bg-slate-900 border border-slate-800 group-hover:border-amber-500 transition-colors">
                  <tc.icon size={18} className="text-slate-300 group-hover:text-amber-400 transition-colors" />
                </div>
                <h3 className="mt-5 font-display text-xl font-bold text-white">{tc.title}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{tc.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
